// TODO: axios baseURL
const url = "/api/v1/";

export const state = {
    programs: {},
    program: {},
    params: {},
};

export const getters = {
    programs: (state) => state.programs,
    program: (state) => state.program,
    params: (state) => state.params,
};

export const mutations = {
    setPrograms(state, programs) {
        state.programs = programs;
    },
    setProgram(state, program) {
        state.program = program;
    },
    setParams(state, params) {
        state.params = params;
    },
    setParamsFields(state, { key, value }) {
        state.params[key] = value;
    },
};

export const actions = {
    async getAll({ commit, dispatch }, page = 1) {
        dispatch("loading/addLoading", "", { root: true });
        const res  = await axios.get(`${url}programs?page=${page}`);
        commit("setPrograms", res.data);
        dispatch("loading/subLoading", "", { root: true });
        return Promise.resolve(res);
    },

    async getOne({ commit, dispatch, state }, page) {
        dispatch("loading/addLoading", "", { root: true });
        const res = await axios.get(
            url +
                "programs" +
                "/" +
                state.params.id +
                "?filter=" +
                (state.params.filter ?? "active") +
                "&page=" +
                (page ?? 1)
        );

        commit("setProgram", res.data);
        dispatch("loading/subLoading", "", { root: true });
        return Promise.resolve(res);
    },

    async setParams({ commit, dispatch }, { id = null, filter = null }) {
        if (id) {
            commit("setParamsFields", { key: "id", value: id });
        }

        if (filter) {
            commit("setParamsFields", { key: "filter", value: filter });
        }

        await dispatch("getOne");
    },
};
